import jQuery from 'jquery';
import './style.scss';
//import './util/triangle';
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import pageTemplatePageMenu from './routes/page-template-page-menu';
import pageTemplatePageProgramm from './routes/page-template-page-programm';
import pageTemplatePageLocationOverview from './routes/page-template-page-location-overview';
import './routes/videos';
import './routes/streams';
import './routes/newsletter';
import "./routes/loadmore";
import "./routes/gallery";
import "./routes/mini-content-slider";
/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  /** All pages */
  common,
  /** Home page */
  //home,
  /** About Us page, note the change from about-us to aboutUs. */
  pageTemplatePageMenu,
  pageTemplatePageProgramm,
  pageTemplatePageLocationOverview,
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());

